module.exports = __webpack_public_path__ + "img/register.a29c9b41.svg";